import {useCallback} from 'react'
import {useHistory, useLocation} from 'react-router-dom'

type GetLinkOptions = {
  href: string
  // Кастомная функция для определения current (опционально)
  isCurrent?: (pathname: string, href: string) => boolean
}

// Дефолтная функция проверки: активно если путь начинается с href
const defaultIsCurrent = (pathname: string, href: string) => {
  const p = pathname.replace(/\/+$/, '')
  const h = href.replace(/\/+$/, '')
  return p === h || p.startsWith(h + '/')
}

/**
 * Возвращает пропсы для ссылок из @superweb/ui.
 */
export function useLinkProps() {
  const {createHref, push} = useHistory()
  const location = useLocation()

  const getLinkProps = useCallback(
    ({href, isCurrent}: GetLinkOptions) => {
      const hrefWithBasename = createHref({pathname: href})
      const current = (isCurrent ?? defaultIsCurrent)(location.pathname, href)

      return {
        href: hrefWithBasename,
        current,
        onClick: (e: React.MouseEvent<HTMLAnchorElement>) => {
          // Открытие в новой вкладке или по правой кнопке мыши не трогаем
          if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) return

          e.preventDefault()
          push(href)
        },
      }
    },
    [createHref, location.pathname, push],
  )

  return {
    getLinkProps,
  }
}
